/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react'

// material-ui
import { Toolbar, Box, Fab } from '@material-ui/core'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import ScrollTop from '../components/ScrollTop/ScrollTop'

// custom component
import SiteHeader from '../components/Headers/SiteHeader'
import FluidContainerList from "../components/Lists/FluidContainerList"

// projects data query
import useProjects from '../data/useProjects'
import Footer from '../components/Footer/Footer'
import useSiteMetaData from '../data/useSiteMetaData'


/**
 * Opinion
 * @param {Object} props - component properties
 * @param {Object} props.location - representing where the app is from a router perspective
 * @returns {*}
 * @constructor
 */
function Projects({ location, navigate }) {
  const siteMeta = useSiteMetaData()
  const projects = useProjects()

  return (
    <React.Fragment>
      <SiteHeader title="Projects" siteMeta={siteMeta} location={location} navigate={navigate} />
      {/* target for scrollTop component - hidden behind header since header is fixed */}
      <Toolbar id="back-to-top-anchor" />
      <Box pt={8} pr={1} pb={2} pl={1}>
        <FluidContainerList edges={projects} location={location} />
      </Box>
      <Footer siteMeta={siteMeta}/>
      <ScrollTop>
        <Fab color="secondary" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </React.Fragment>
  )
}

export default Projects
